export default __webpack_public_path__ + "static/media/welink.d972c56f.png";